import { render, staticRenderFns } from "./politicaPrivacidad.vue?vue&type=template&id=55e02187&scoped=true"
import script from "./politicaPrivacidad.vue?vue&type=script&lang=js"
export * from "./politicaPrivacidad.vue?vue&type=script&lang=js"
import style0 from "./politicaPrivacidad.vue?vue&type=style&index=0&id=55e02187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e02187",
  null
  
)

export default component.exports